/** @format */

import { CookieService } from './cookie.service';
import { WINDOW } from './window/window.service';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HeaderLocationService {
  constructor(
    private cookieService: CookieService,
    @Inject(WINDOW) protected window: Window,
  ) {}

  /**
   * @description Look for the deliveryZip cookie and return the value
   * @return a zip code as a string ex: 15108
   */
  getDeliveryZipCookie() {
    // get the user delivery zip cookie
    if (
      this.cookieService.check('deliveryZip') &&
      this.cookieService.get('deliveryZip') &&
      this.cookieService.get('deliveryZip') !== 'null'
    ) {
      return this.cookieService.get('deliveryZip');
    }
    return null;
  }

  /**
   * @description Look for the whereabouts cookie and return the value
   * @returns a zip code as a string ex: 15108
   */
  getWhereaboutsCookie() {
    if (
      this.cookieService.check('whereabouts') &&
      this.cookieService.get('whereabouts') &&
      this.cookieService.get('whereabouts') !== 'null'
    ) {
      return this.cookieService.get('whereabouts');
    }
    return null;
  }

  /**
   * @description Look for the DCSG_NGX_CUST_STORE cookie,
   * returns an array of values split by an underscore
   * take the index of 1 to return the store name as a string
   * @returns store name as string
   */
  getDcsgCustStoreCookie() {
    if (
      this.cookieService.check('DCSG_NGX_CUST_STORE') &&
      this.cookieService.get('DCSG_NGX_CUST_STORE')
    ) {
      return this.cookieService.get('DCSG_NGX_CUST_STORE').split('_')[1];
    }
    return null;
  }
}
